import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-route-list',
  templateUrl: './route-list.component.html',
  styleUrls: ['./route-list.component.scss'],
})
export class RouteListComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
